import { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';

import Home from './../Pages/Home';
import AboutUs from './../Pages/AboutUs';
import PrivacyPolicy from './../Pages/PrivacyPolicy';
import Page404 from '../Pages/Page404';
import LayoutWithNavAndFooter from '../Layouts/LayoutWithNavAndFooter';
import ContactUs from '../Pages/ContactUs';
import Stores from '../Pages/Stores';
import NoInternet from '../Pages/NoInternet';
// import TermsAndConditions from '../Pages/TermsAndConditions';
import SupplyPrices from './../Pages/SupplyPrices';
import InviteFriends from '../Pages/InviteFriends';
import Solutions from '../Pages/Solutions';
import PartnerShips from '../Pages/PartnerShips';

const AppRoutes = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleOffline = () => {
      navigate('/no-internet');
    };
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <Routes>
      <Route element={<LayoutWithNavAndFooter />}>
        <Route index element={<Navigate to={'/home'} />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        {/* <Route path="/terms-and-conditions" element={<TermsAndConditions />} /> */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/stores" element={<Stores />} />
        <Route path="/supply-prices" element={<SupplyPrices />} />
        <Route path="/partnerships" element={<PartnerShips />} />
        <Route path="/solutions" element={<Solutions />} />
      </Route>
      <Route path="/refer" element={<InviteFriends />} />
      <Route path="*" element={<Page404 />} />
      <Route path="/no-internet" element={<NoInternet />} />
    </Routes>
  );
};

export default AppRoutes;
